<template lang="pug">
section
  .blocks
    .block(v-for="block of blocks" :key="'block_' + block.name" :class="{'opened': block.opened}")
      h3(@click="block.opened = !block.opened") {{ block.name }}
      .block-content
        .content(v-for="l of block.list")
          .title(v-if="l.key") {{ l.key }}:
          ul.list
            li(v-for="item of l.items")
              span {{ item }}

  .blocks.two-cols
    .block(v-for="block of aBlocks" :key="'block_' + block.name" :class="{'opened': block.opened}")
      h3(@click="block.opened = !block.opened") {{ block.name }}
      .block-content
        .content(v-for="l of block.list")
          .title(v-if="l.key") {{ l.key }}:
          ul.list
            li.simple(v-for="item of l.items")
              span {{ item }}

</template>

<script>
import {mainBlocks} from '@/contents/services';
import {additionalBlocks} from '@/contents/services';

export default {
name: "Oferta",
  data() {
    return {
      blocks: {},
      aBlocks: {}
    }
  },
  mounted() {
    this.blocks = mainBlocks
    this.aBlocks = additionalBlocks
  }
}
</script>

<style scoped>

</style>
